export default {"src":"/_next/static/media/diamond-purple.86480ac2.svg","height":25,"width":26};